import './App.css';
import{ BrowserRouter as Router,Routes,Route } from "react-router-dom"
import ExamInstruction from './Component/ExamInstruction/ExamInstruction';
import Header from './Component/Header/Header';
import Login from './Component/Login/Login';
import EmployeeInformation from './Component/EmployeeInformation/EmployeeInformation';
import QuestionContainer from './Component/Question/QuestionContainer';
import Timer from './Component/Timer';
import { connect } from 'react-redux';
import{contentAfterLogin}from "./redux/action-creator"
// import { connect } from 'react-redux';
import Home from './Component/Home/Home';
// import { Result } from 'antd';
import Result from './Component/Result';
// import { Footer  from 'antd/lib/layout/layout';
import Footer from './Component/Footer/Footer';

import ReactProject from './Component/ReactProject/ReactProject';
import ROR from './Component/ROR/ROR';
import HTMLCSS from './Component/HTMLCSS/HTLMLCSS';
import HCJ from './Component/HCJ/HCJ';
import Mern from './Component/Mern/Mern';
import Node from './Component/Node/Node';
import Forgotpass from "./Component/ForgotPassword/Forgotpass"

import ReaRud from './Component/ReaRud/ReaRud';
// import { store } from './redux/store';
import Signin from './Component/Sign/Signin';
import SignUp from './Component/SignUp/SignUp';
function App(props) {

  // console.log("++++ isQuizz ++++",isQuizz)
  return (
    <div className="App">
      <Router>
       <Header />
      <Routes>
        <Route exact path="/reactreduxproject" element={<ReaRud />} />
        <Route exact path="changepassword" element={<Forgotpass />} />
        <Route exact path="/signup" element={<SignUp />}/>
        {
          !props.adCa?        <Route exact path="/signin" element={<Signin />} />:null

        }

        <Route exact path="/mernproject" element={<Mern />} />
        <Route exact path="/htmlcssjsproject" element={<HCJ />} />
        <Route exact path="/htmlcssproject" element={<HTMLCSS />} />
        <Route exact path="/nodeproject" element={<Node /> } />
        <Route exact path="/rorproject" element={<ROR />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/" element={<Home />} />
       <Route exact path="/result" element={<Result />} />
     <Route exact path="/reactproject" element={<ReactProject />} />
     <Route exact path="/examinstruction" element={<ExamInstruction /> }/>
      <Route exact path="/nav" element={<QuestionContainer/>}/>
     <Route exact path="/employeedetails" element={<EmployeeInformation /> }/>
     <Route exact path ="/question" element={<  QuestionContainer />} />
     <Route exact path="/timefinished" element ={ <Timer/> }  />
      </Routes>
      <Footer />

      </Router>
    </div>
  );
}
const mapStateToProps=(state)=>{
  return{
      adCa:state.ourState.showNav

  }
}
const mapDispatchToProps=(dispatch)=>{
  return{
  testFun:()=>dispatch(contentAfterLogin())
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(App)

// export default App;
